import { render, staticRenderFns } from "./setUp2.vue?vue&type=template&id=155d16d2&scoped=true&"
import script from "./setUp2.vue?vue&type=script&lang=js&"
export * from "./setUp2.vue?vue&type=script&lang=js&"
import style0 from "./setUp2.vue?vue&type=style&index=0&id=155d16d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155d16d2",
  null
  
)

export default component.exports